<template>
  <div class="leading-4 text-xs italic">
    <slot />
  </div>
</template>
